/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Setpointstartfrostfreeamb4Inputs */



/**
* | output |
* | --- |
* | "Ambient frost-free start setpoint" |
*
* @param {Ahu_History_Key_Setpointstartfrostfreeamb4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_setpointstartfrostfreeamb4 = /** @type {((inputs?: Ahu_History_Key_Setpointstartfrostfreeamb4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Setpointstartfrostfreeamb4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient frost-free start setpoint")
	return /** @type {LocalizedString} */ ("Consigne de départ hors gel d'ambiance")
});
export { ahu_history_key_setpointstartfrostfreeamb4 as "ahu_history_key_setpointStartFrostFreeAmb" }